import { Tag, Tooltip } from 'antd';
import { twMerge } from '@utils/twMerge';
import { highlightMatches } from '@utils/highlightMatches';
import { MAX_LABEL_LENGTH } from '@components/SelectLabels/SelectLabels';
import { FC } from 'react';
import { FlattenOptionData } from 'rc-select/lib/interface';
import { BaseOptionType } from 'rc-select/lib/Select';


type SelectLabelsOptionRenderProps = {
  option: FlattenOptionData<BaseOptionType>;
  searchValue: string;
  isItemSelected: (value: string) => boolean;
};

export const HiddenTag = () => {
  return <Tag className='hidden' />;
};

export const SelectLabelsOptionRender: FC<SelectLabelsOptionRenderProps> = ({
  option,
  searchValue,
  isItemSelected,
}) => {
  return (
    <div className='flex items-center justify-between px-1'>
      <Tooltip
        color='white'
        title={
          option.data.label.length > MAX_LABEL_LENGTH ? (
            <span className='text-1424 text-black'>{option.data.label}</span>
          ) : undefined
        }
      >
        <span
          className={twMerge(
            'text-1624 font-medium leading-6',
            option.data.label.length > MAX_LABEL_LENGTH &&
              'max-w-[32rem] truncate'
          )}
        >
          {highlightMatches(option.data.label, searchValue)}
        </span>
      </Tooltip>
      {!isItemSelected(option.data.value) && !option.data.disabled ? (
        <span className='text-vividTangelo'>Add</span>
      ) : (
        <span className='text-pastelBlue'>Added</span>
      )}
    </div>
  );
};
